import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";
import { dispatchAddToCartEvent } from "@store/Services/AnalyticsService";

addToChainAfter(chain, SendDataToApi, props => {
    const state = props.getState();
    const currentCurency = state.context.session.currency?.currencyCode;
    if (props.apiParameter.cartLines) {
        dispatchAddToCartEvent(props.apiParameter.cartLines, currentCurency);
    }
});
